import React, { useEffect } from 'react'
import { useHistory } from 'react-router';
import { getSession, valdiatePage } from '../../global';

const Userguide = () => {
    const history = useHistory();
    useEffect(() => {
        if (valdiatePage('/addresslabel')) {

        } else {
            history.push('/login');
        }
        return () => {

        }
    }, []);

    return getSession('userInfo') && <section className="section">
        <div className="section-header">
            <h1>User Guide</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row mb-3"><div className="col-2" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}><h3 style={{ margin: 0 }}>Customer Portal</h3></div><div className="col-2"><a href='/cplight/Customer_Portal_Manual.pdf' className="btn btn-primary">Download</a></div></div>
            <div className="row mb-3"><div className="col-2" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}><h3 style={{ margin: 0 }}>COD API</h3></div><div className="col-2"><a href='/cplight/API_Documentation.pdf' className="btn btn-primary">Download</a></div></div>
            <div className="row mb-3"><div className="col-2" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}><h3 style={{ margin: 0 }}>Shopify Plugin</h3></div><div className="col-2"><a href='/cplight/M&P_Shopify_Manual.pdf' className="btn btn-primary">Download</a></div></div>
            <div className="row mb-3"><div className="col-2" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}><h3 style={{ margin: 0 }}>Manganto Plugin</h3></div><div className="col-2"><a href='/cplight/MNP_Magento_Manual.pdf' className="btn btn-primary">Download</a></div></div>
            <div className="row mb-3"><div className="col-2" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}><h3 style={{ margin: 0 }}>Woocommerce Plugin</h3></div><div className="col-2"><a href='/cplight/MNP_Woocommerce_Manual.pdf' className="btn btn-primary">Download</a></div></div>
        </div>
    </section>
}

export default Userguide;